import type { StaticLandingPage } from '../../../content';
import heroCisoBanner from './assets/hero-ciso-banner.png';
import audienceCybersecurityTraining from './assets/audience-cybersecurity-training.jpg';
import brochureCiso from './assets/downloads/Chief_Information_Security_Office_CISO_Career_Path_2pgs_SA.pdf';
// Testimonials hidden per ACCS feedback (#15); imports retained (commented) for re-enable
// import testimonialRajeshKumar from './assets/testimonial-rajesh-kumar.jpg';
// import testimonialPriyaSharma from './assets/testimonial-priya-sharma.jpg';
// import testimonialArjunMenon from './assets/testimonial-arjun-menon.jpg';
// Trainers section hidden per ACCS feedback (#17); imports retained (commented) for re-enable
// import trainerVikramPatel from './assets/trainer-vikram-patel.jpg';
// import trainerAnanyaDesai from './assets/trainer-ananya-desai.jpg';
// import trainerSureshIyer from './assets/trainer-suresh-iyer.jpg';

export const academyInCisoPage = {
  slug: 'aca-in-ciso',
  archetype: 'lead-gen',
  body: [
    {
      _uid: '68f696c8-7568-4b62-bd6c-ead4c8861d28',
      title: 'Chief Information Security Officer',
      variant: 'lead',
      subtitle: 'CISO Career Path — Designed for Cybersecurity Professionals',
      component: 'hero_section',
      hero_image: {
        alt: 'Business professional activating a digital security padlock',
        filename: heroCisoBanner,
      },
      hero_stats: [
        { _uid: 'hero-chip-1', icon: 'groups', text: 'Face-to-face Training', component: 'icon_text_item' },
        { _uid: 'hero-chip-2', icon: 'schedule', text: '23 Days', component: 'icon_text_item' },
      ],
      highlights: [
        {
          _uid: '5e9a97b2-d8ed-4d8c-8089-bcbde6b516e8',
          icon: 'schedule',
          title: '7 Modules',
          component: 'icon_text_item',
        },
        {
          _uid: 'dbe32522-aeda-4907-bf08-6ee92046a1f0',
          icon: 'workspace_premium',
          title: 'TÜV SÜD Certification',
          component: 'icon_text_item',
        },
        {
          _uid: '4c769fed-991a-4832-8a00-a301a404c4ea',
          icon: 'groups',
          title: 'Expert Trainers',
          component: 'icon_text_item',
        },
        {
          _uid: '2bc7c160-92c4-4339-9bc4-e29194a3f676',
          icon: 'verified',
          title: 'Globally Recognized',
          component: 'icon_text_item',
        },
      ],
      description:
        "A Chief Information Security Officer (CISO) is a senior executive within an organization who is responsible for overseeing all aspects of information security. They are tasked with developing and implementing a comprehensive security program to protect the organization's data, systems, and infrastructure from cyber threats. TÜV SÜD Chief Information Security Officer – CISO Career Path provides a professional necessary credential to become a CISO in a corporate organization, who will be the overseer of information security related activities. Various constituent modules of this course will take the professional through relevant knowledge areas to acquire the competence to play the role of a CISO.",
      badge_1_text: 'New Batch Starting Soon',
      badge_2_text: 'TÜV SÜD Certification',
      academy_label: 'TÜV SÜD Academy',
      academy_link: 'https://www.tuvsud.com/en-in/store/academy-in',
      nav_cta_label: 'Request Callback',
      hero_image_alt: 'Business professional activating a digital security padlock',
      primary_cta_label: 'Download Free Brochure',
      secondary_cta_label: 'Request a Callback',
    },
    /* Trust bar hidden per ACCS feedback (#6)
    {
      _uid: 'c1c47542-8a13-43f9-b1e0-d426031bec55',
      label: 'Trusted by Industry Leaders',
      partners: [
        {
          _uid: 'b0f83ea4-685e-4157-8340-017410a926ed',
          name: 'ISO 27001',
          label: 'ISO 27001 Certified',
          component: 'partner_item',
        },
        {
          _uid: 'acc5efd0-6a4b-452a-bbd5-f6762ae2ab94',
          name: 'CSA',
          label: 'Cloud Security Alliance',
          component: 'partner_item',
        },
        {
          _uid: '3486d32d-3bf0-407e-9081-53706135eceb',
          name: 'ISACA',
          label: 'ISACA Recognized',
          component: 'partner_item',
        },
        {
          _uid: '8805022f-fe24-4c24-a2d3-e55ac58e81ee',
          name: 'ISC2',
          label: 'ISC2 Partner',
          component: 'partner_item',
        },
      ],
      component: 'trust_bar_section',
    },
    */
    {
      _uid: 'c6551ccd-183f-41a7-920d-b0bf6e48dec4',
      title: 'Benefits That Set You Apart',
      eyebrow: 'Why Choose CISO',
      benefits: [
        {
          _uid: 'a4b061b7-a209-4c80-8d97-ccc3c22e8dc1',
          icon: 'menu_book',
          title: 'Comprehensive Syllabus',
          component: 'icon_text_item',
          description:
            'A detailed syllabus covering information security, risk & incident management, policy formulation, data privacy and business continuity within IT governance.',
        },
        {
          _uid: '489bb41f-c2ed-4824-8b8e-467b678032a9',
          icon: 'cloud',
          title: 'Advanced Security Technologies',
          component: 'icon_text_item',
          description: 'Knowledge of advanced information security technologies, including cloud security and artificial intelligence.',
        },
        {
          _uid: '977a6b26-bdd8-4646-9754-deb5f0050048',
          icon: 'visibility',
          title: 'Strategic Enterprise Perspective',
          component: 'icon_text_item',
          description: 'Develop a holistic, strategic perspective to manage security activities effectively across the enterprise.',
        },
        {
          _uid: '1f1661a3-ae8f-4905-a4da-16132e2fec82',
          icon: 'trending_up',
          title: 'Leadership & Governance',
          component: 'icon_text_item',
          description: 'Enhance leadership skills and deepen your understanding of information security governance for career growth.',
        },
        {
          _uid: '6f250709-8a6c-482d-aa76-213ecb5a4c17',
          icon: 'workspace_premium',
          title: 'Globally Recognized CISO Credential',
          component: 'icon_text_item',
          description: 'Demonstrate competence and gain recognition through a globally recognized CISO credential.',
        },
        {
          _uid: '3f519f43-4c04-4040-9324-a210de8be967',
          icon: 'shield',
          title: 'Lead Enterprise Security',
          component: 'icon_text_item',
          description:
            'Be prepared to lead and oversee all information security initiatives with confidence and an enterprise-wide perspective.',
        },
      ],
      component: 'benefits_section',
      description:
        'The CISO Career Path equips experienced professionals to lead and oversee all aspects of enterprise information security.',
    },
    {
      _uid: 'e86590a1-2094-47fe-be18-967fc5cdb59e',
      // Stats grid hidden per ACCS feedback (#10); only the CTA below is shown (#11)
      stats: [],
      cta_text: 'Join the league of TÜV SÜD certified information security leaders',
      component: 'stats_section',
      cta_label: 'Start Your Journey — Enquire Now',
    },
    {
      _uid: '920d44a6-4add-4d6e-b18e-2b0b94d1e83b',
      title: '7 Comprehensive Modules',
      eyebrow: 'Curriculum',
      modules: [
        {
          _uid: 'e2d56eee-4b2b-4226-bb11-fd307488c1e9',
          icon: 'account_balance',
          type: 'Mandatory',
          title: 'IT Information Security Governance',
          number: '01',
          component: 'module_item',
          description: 'IT governance elements that align information security with the organization’s business objectives.',
        },
        {
          _uid: '9761750f-509f-4279-bd5b-7502b0ada050',
          icon: 'warning',
          type: 'Substitutable*',
          title: 'IT Risk & Incident Management',
          number: '02',
          component: 'module_item',
          description: 'Identify, assess, and manage IT risks and respond effectively to security incidents.',
        },
        {
          _uid: 'f8384449-be67-4911-aa96-33ba36e2646e',
          icon: 'cloud',
          type: 'Substitutable*',
          title: 'Cloud Security Professional',
          number: '03',
          component: 'module_item',
          description: 'Apply cloud security principles to protect cloud-based infrastructure and services.',
        },
        {
          _uid: '3e637100-a329-4be4-8476-145224ad08be',
          icon: 'smart_toy',
          type: 'Substitutable*',
          title: 'AI & Data Privacy Professional',
          number: '04',
          component: 'module_item',
          description:
            'AI management integrated with data privacy — combining ISO 42001 and ISO 27701. Focused on AI governance, not AI development.',
        },
        {
          _uid: '0467f4c9-1c7c-4100-8d43-c734e2a349fc',
          icon: 'autorenew',
          type: 'Substitutable*',
          title: 'ISO 22301 BCMS Lead Auditor / Lead Implementer',
          number: '05',
          component: 'module_item',
          description: 'Develop and manage business continuity plans to maintain operations during disruptions.',
        },
        {
          _uid: '9f4ffcd0-5da3-4e82-978a-2c650813a894',
          icon: 'policy',
          type: 'Substitutable*',
          title: 'ISO 27001 ISMS Lead Auditor / Lead Implementer',
          number: '06',
          component: 'module_item',
          description: 'Establish, implement, maintain, and improve an Information Security Management System.',
        },
        {
          _uid: 'ad5c6a28-e19b-4dbc-9702-bb4846156f5f',
          icon: 'emoji_events',
          type: 'Mandatory',
          title: 'CISO Qualifier Training & Exam',
          number: '07',
          component: 'module_item',
          description:
            'The final module covering project management and aligning all modules to qualify for the CISO Career Path exam.',
        },
      ],
      footnote:
        '* Substitutable modules can be replaced with equivalent certifications (ISACA, CSA, ISC2 or relevant ISO standards). Up to two certifications accepted from outside TÜV SÜD.',
      inline_links: [{ term: 'ISC2', url: 'https://www.isc2.org/' }],
      component: 'modules_section',
      cta_label: 'Get Detailed Curriculum',
      description:
        'Six specialised modules build toward the central CISO Qualifier Training & Exam, certifying your readiness to lead and oversee enterprise-wide information security.',
    },
    {
      _uid: '82312024-4f19-4e75-9a6d-00e789a42133',
      image: {
        alt: 'Cybersecurity training session',
        filename: audienceCybersecurityTraining,
      },
      title: 'Who Should Attend?',
      eyebrow: 'Target Audience',
      audiences: [
        {
          _uid: 'ddbcbb4d-b8e4-4283-aa51-9ca7b8e4d45f',
          icon: 'manage_accounts',
          title: 'Information Security Managers',
          component: 'icon_text_item',
          description: 'Security managers ready to step up into a CISO or senior information security leadership role.',
        },
        {
          _uid: 'b9cdfdfa-d52a-41a5-a484-9e95ed331500',
          icon: 'security',
          title: 'Information Security Professionals',
          component: 'icon_text_item',
          description:
            'Experienced information security and cybersecurity professionals (5+ years), including audit and compliance.',
        },
        {
          _uid: '92d0ffe0-39a8-4c63-98fe-1cd78517476f',
          icon: 'trending_up',
          title: 'Aspiring CIOs & CISOs',
          component: 'icon_text_item',
          description: 'Professionals targeting Chief Information Officer or Chief Information Security Officer positions.',
        },
        {
          _uid: '8c847ed8-671d-4979-ad0d-e574270d455c',
          icon: 'fact_check',
          title: 'Security Consultants & Auditors',
          component: 'icon_text_item',
          description: 'Information security consultants and auditors broadening into security leadership.',
        },
        {
          _uid: '6e86bfd4-133d-45b6-9723-49946e8b9ede',
          icon: 'gavel',
          title: 'Risk & Governance Professionals',
          component: 'icon_text_item',
          description: 'Professionals working in information security governance, risk, audit and compliance.',
        },
        {
          _uid: 'd6d9ebf1-a8d5-4a28-9a95-6a1be2842ba9',
          icon: 'school',
          title: 'Aspiring Security Leaders',
          component: 'icon_text_item',
          description: 'Anyone with relevant experience seeking to advance their career into information security leadership.',
        },
      ],
      component: 'audience_section',
      cta_label: 'Enquire Now',
      image_alt: 'Information security leadership training',
      description:
        'This course is ideal for information security professionals with at least five years of experience who want to step into a CISO or senior security leadership role.',
    },
    /* Testimonials hidden per ACCS feedback (#15) — no alumni testimonials yet; re-enable once available
    {
      _uid: '6966b793-d9a3-46a6-b669-38c39dfdc8a9',
      title: 'What Our Alumni Say',
      eyebrow: 'Success Stories',
      variant: 'lead',
      component: 'testimonials_section',
      description:
        'Feedback from participants who used the ACCS programme to strengthen their cybersecurity expertise and career path.',
      testimonials: [
        {
          _uid: '2f08b83d-a9e9-42ac-8e9d-6b20a2141343',
          name: 'Rajesh Kumar',
          role: 'Security Analyst, Wipro',
          image: {
            alt: 'Rajesh Kumar',
            filename: testimonialRajeshKumar,
          },
          quote:
            'The ACCS program gave me a holistic view of cybersecurity that I never had before. The hands-on labs and the calibre of TÜV SÜD trainers were exceptional.',
          rating: 5,
          component: 'testimonial_item',
        },
        {
          _uid: 'ff180b76-a2e0-448b-b1a8-57705293ef70',
          name: 'Priya Sharma',
          role: 'IT Risk Manager, Infosys',
          image: {
            alt: 'Priya Sharma',
            filename: testimonialPriyaSharma,
          },
          quote: 'What sets ACCS apart is the breadth of coverage — from network security to AI & data privacy.',
          rating: 5,
          component: 'testimonial_item',
        },
        {
          _uid: '0fbd5e7a-c432-434c-898d-6a998915fb06',
          name: 'Arjun Menon',
          role: 'Cloud Security Lead, TCS',
          image: {
            alt: 'Arjun Menon',
            filename: testimonialArjunMenon,
          },
          quote: 'The cloud security and ISO 27001 modules were invaluable.',
          rating: 5,
          component: 'testimonial_item',
        },
      ],
    },
    */
    {
      _uid: '571e5008-887b-471a-b5f6-baa6a2672214',
      title: 'Learn From the Best',
      eyebrow: 'Expert Faculty',
      // Trainer profile cards removed per ACCS feedback; heading + description kept
      trainers: [],
      component: 'trainers_section',
      description:
        'Our trainers are industry veterans with decades of cybersecurity, governance and compliance experience.',
    },
    {
      _uid: 'c735505d-a2ba-4f63-894d-86982ced7f64',
      title: 'Download Free Brochure & Get Expert Guidance',
      eyebrow: 'Get Started Today',
      component: 'form_section',
      provider: 'marketo',
      base_url: '//ts.tuvsud.com',
      munchkin_id: '819-PVY-502',
      form_id: 28959,
      anchor_id: 'form',
      form_title: 'Enquire Now — Free Brochure',
      button_text: 'Download Brochure & Get Callback',
      inline_success: true,
      success_title: 'Thank you! We have received your details.',
      success_text:
        'Your brochure is ready to download below. Our training advisor will also reach out shortly with batch schedules and the next steps.',
      success_downloads: [{ label: 'CISO Career Path — Brochure (PDF)', url: brochureCiso }],
      trust_title: 'Your information is safe with us',
      trust_text: 'We respect your privacy. No spam, ever.',
      privacy_policy_url: 'https://www.tuvsud.com/en-in/store/academy-in/privacy-policy',
      terms_url: 'https://www.tuvsud.com/en-in/terms-and-conditions',
      description:
        'Fill in your details and our training advisor will contact you with a personalized learning plan, batch schedules, and exclusive pricing.',
      value_points: [
        {
          _uid: 'e4f04b84-3887-44ee-9710-9ad82d914373',
          icon: 'description',
          title: 'Detailed program brochure with full curriculum',
          component: 'icon_text_item',
        },
        {
          _uid: 'df8d3eae-9f19-4d60-9d6b-b3c5836f3dab',
          icon: 'calendar_month',
          title: 'Upcoming batch schedules & training calendar',
          component: 'icon_text_item',
        },
        {
          _uid: 'a65d8a87-de7b-4049-ad93-77709f3cdc36',
          icon: 'local_offer',
          title: 'Exclusive pricing for early registrations',
          component: 'icon_text_item',
        },
        {
          _uid: '05f55ad5-1e11-434f-9a3e-0d1ebb49078d',
          icon: 'support_agent',
          title: 'Free 1-on-1 career counselling session',
          component: 'icon_text_item',
        },
      ],
    },
    {
      _uid: 'a8e95182-a4dc-4158-981a-5fe5debf82f6',
      faqs: [
        {
          _uid: 'c1a0e7b2-0001-4a10-9b21-aa11bb22cc01',
          question: 'What will you learn?',
          answer:
            'By the end of this course, participants will be able to lead and oversee all aspects of information security across an organization.',
          answer_blocks: [
            { type: 'paragraph', text: 'By the end of this course, participants will be able to:' },
            {
              type: 'list',
              items: [
                'Understand the roles and responsibilities of a Chief Information Security Officer within an organization.',
                'Develop and implement comprehensive information security strategies and programs.',
                'Identify, assess, and manage cyber risks and threats to organizational assets.',
                'Demonstrate knowledge of key cybersecurity elements and their application in organizational security.',
                'Apply principles of cloud security to protect cloud-based infrastructure and services.',
                'Understand IT governance elements to ensure alignment of information security with business objectives.',
                'Develop and manage business continuity plans to maintain operations during disruptions.',
                'Implement robust information security controls across the organization.',
                'Recognize the role of artificial intelligence in enhancing security measures and threat detection.',
                'Ensure compliance with data privacy regulations and best practices to protect sensitive information.',
                'Oversee information security policies, procedures, and compliance requirements.',
                'Demonstrate competence in leading and coordinating information security initiatives across an organization.',
                'Successfully complete the CISO Qualifier module to achieve CISO qualification.',
              ],
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'c1a0e7b2-0002-4a10-9b21-aa11bb22cc02',
          question: 'Career path benefits',
          answer:
            'A globally recognized CISO credential with a comprehensive syllabus, advanced security technologies, and a strategic enterprise-wide perspective.',
          answer_blocks: [
            {
              type: 'list',
              items: [
                'Provides a detailed and comprehensive syllabus covering all critical aspects of information security, risk management, incident management, policy formulation, data privacy, and business continuity within the framework of IT governance.',
                'Equips professionals with knowledge of advanced information security technologies, including cloud security and artificial intelligence.',
                'Enables security professionals to develop a holistic and strategic perspective, allowing them to manage security activities across the enterprise effectively.',
                'Helps participants demonstrate competence and gain recognition through a globally recognized CISO credential.',
                'Supports career growth by enhancing leadership skills and deepening understanding of information security governance.',
                'Prepares aspiring CISOs and other security professionals to lead and oversee all information security initiatives with confidence and a broad enterprise-wide perspective.',
              ],
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'c1a0e7b2-0003-4a10-9b21-aa11bb22cc03',
          question: 'Who should attend?',
          answer:
            'Information security professionals with at least five years of experience who want to step into a CISO or senior security leadership role.',
          answer_blocks: [
            {
              type: 'paragraph',
              text: 'This course is ideal for professionals currently working in information security with at least five years of experience in various aspects of information security and cybersecurity, including audit and compliance. It is specifically designed for:',
            },
            {
              type: 'list',
              items: [
                'Information Security Managers',
                'Information Security Professionals',
                'Aspiring Chief Information Officers (CIOs) and Chief Information Security Officers (CISOs)',
                'Information Security Consultants and Auditors',
                'Anyone seeking to advance their career in information security',
              ],
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'c1a0e7b2-0004-4a10-9b21-aa11bb22cc04',
          question: 'Pre-requisites',
          answer:
            'Basic IT and information security knowledge plus a minimum of 5 years of professional experience in IT and information security roles.',
          answer_blocks: [
            {
              type: 'list',
              items: [
                'Basic knowledge of IT and information security concepts.',
                'A minimum of 5 years of professional experience in IT and information security roles.',
              ],
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'c1a0e7b2-0005-4a10-9b21-aa11bb22cc05',
          question: 'Terms for CISO Qualification',
          answer:
            'Selected modules can be substituted with recognized ISACA, CSA, ISC2 or ISO certifications; up to two certifications may be accepted from outside TÜV SÜD.',
          answer_blocks: [
            {
              type: 'list',
              items: [
                "*IT Risk & Incident Management Module can be substituted with any one of ISACA certifications – CISA OR CISM OR CRISC OR (ISC)2's CISSP certification.",
                "*Cloud Security Module can be substituted with any one of CSA certifications - CCSK Foundation OR CCSK Plus OR (ISC)2's CCSP Certification.",
                '*Artificial Intelligence & Data Privacy Module can be substituted with ISO 42001 Artificial Intelligence Management System (AIMS) Lead Auditor OR Lead Implementer and ISO 27701 Privacy Information Management System (PIMS) Lead Auditor OR Lead Implementer.',
                '*ISO 27001 Information Security Management System (ISMS) Lead Auditor OR Lead Implementer certification can be accepted from outside of TÜV SÜD.',
                '*ISO 22301 Business Continuity Management System (BCMS) Lead Auditor OR Lead implementer certification can be accepted from outside of TÜV SÜD.',
                'Up to two certifications will be allowed from outside of TÜV SÜD.',
                'Qualifier Training includes topics on project management and aligns all the modules to qualify for the Qualifier Exam of CISO Career Path.',
              ],
            },
          ],
          component: 'faq_item',
        },
        {
          _uid: 'c1a0e7b2-0006-4a10-9b21-aa11bb22cc06',
          question: 'Examination & Certification',
          answer:
            'Each module ends with an assessment, and a scenario-based Qualifier exam must be passed to obtain the full TÜV SÜD CISO certification.',
          answer_blocks: [
            {
              type: 'list',
              items: [
                'At the end of each module, candidates must pass an assessment to demonstrate their understanding of the material.',
                'The final Qualifier exam consists of scenario-based multiple-choice questions (MCQs).',
                'Successful completion of the Qualifier module is mandatory to achieve eligibility for the TÜV SÜD CISO career path qualification.',
                'Candidates must pass all module assessments, including the Qualifier exam, to obtain the full CISO certification.',
              ],
            },
          ],
          component: 'faq_item',
        },
      ],
      title: 'Frequently Asked Questions',
      eyebrow: 'FAQ',
      variant: 'lead',
      component: 'faq_section',
      inline_links: [{ term: 'ISC2', url: 'https://www.isc2.org/' }],
      bottom_text: 'Still have questions? Our training advisors are happy to help!',
      description: 'Important questions about course structure, eligibility, scheduling, and advisor support.',
      whatsapp_url: {
        id: '',
        url: 'https://wa.me/919186556246?text=Hi%2C%20I%20have%20a%20question%20about%20the%20CISO%20program',
        target: '_blank',
        linktype: 'url',
        fieldtype: 'multilink',
        cached_url: 'https://wa.me/919186556246?text=Hi%2C%20I%20have%20a%20question%20about%20the%20CISO%20program',
      },
      contact_title: 'Still have questions?',
      accordion_label: 'Frequently Asked Questions',
      advisor_cta_label: 'Talk to an Advisor',
      whatsapp_cta_label: 'Chat on WhatsApp',
      contact_description: 'Our advisors can help you evaluate the right module path, fees, and upcoming intake dates.',
    },
    {
      _uid: '3c1f2818-013a-4588-8942-56a8e165f23b',
      variant: 'lead',
      component: 'footer_section',
      about_text:
        "TÜV SÜD is one of the world's leading technical service organizations with over 150 years of domain expertise. TÜV SÜD Academy offers world-class training and certification programs.",
      legal_links: [
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/en-in/-/media/regions/in/pdf-files/terms-and-conditions/standard-terms--conditions-for-estore-academy.pdf',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url:
              'https://www.tuvsud.com/en-in/-/media/regions/in/pdf-files/terms-and-conditions/standard-terms--conditions-for-estore-academy.pdf',
          },
          _uid: 'a6f1c2d4-8e3b-4f1a-9c7d-2b5e0a4f1d10',
          label: 'Terms and Condition',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/en-in/store/academy-in/cancellation-policy',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/en-in/store/academy-in/cancellation-policy',
          },
          _uid: 'b7e2d3f5-9f4c-4a2b-8d6e-3c6f1b5a2e21',
          label: 'Cancellation Policy',
          component: 'link_item',
        },
      ],
      quick_links: [
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/en-in/store/academy-in',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/en-in/store/academy-in',
          },
          _uid: '8b4d6b7b-27c0-42a2-b752-2e262cc86517',
          label: 'Academy Store',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.tuvsud.com/en-in/store/academy-in/sectors/information-technology',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.tuvsud.com/en-in/store/academy-in/sectors/information-technology',
          },
          _uid: '130b5d19-6997-4fa8-bcec-968fd02667f4',
          label: 'Cyber Security Training',
          component: 'link_item',
        },
      ],
      social_links: [
        {
          url: {
            id: '',
            url: 'https://www.linkedin.com/company/tuvsud/',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.linkedin.com/company/tuvsud/',
          },
          _uid: '615150b9-9de7-4462-a597-fdee3e8587db',
          label: 'LinkedIn',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.youtube.com/TUVSUD',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.youtube.com/TUVSUD',
          },
          _uid: 'cf43553f-e217-4a5d-9749-943d6d424f87',
          label: 'YouTube',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.facebook.com/tuvsud',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.facebook.com/tuvsud',
          },
          _uid: '14205c9b-459f-44e5-b5e5-b7e3281e9684',
          label: 'Facebook',
          component: 'link_item',
        },
        {
          url: {
            id: '',
            url: 'https://www.instagram.com/tuvsud/',
            target: '_blank',
            linktype: 'url',
            fieldtype: 'multilink',
            cached_url: 'https://www.instagram.com/tuvsud/',
          },
          _uid: 'd84226e4-e164-4cc8-994d-ac3817a29241',
          label: 'Instagram',
          component: 'link_item',
        },
      ],
      contact_email: 'academy.in@tuvsud.com',
      contact_phone: '+91 22 6274 5000',
      copyright_text: '© 2026 TÜV SÜD. All rights reserved.',
      contact_address: 'TÜV SÜD South Asia,\nMumbai, Maharashtra, India',
      primary_column_label: 'Quick Links',
      secondary_column_label: 'Contact India',
    },
    {
      _uid: '23ec3496-3e62-4b7c-b25d-d2ad28309a68',
      title: 'TÜV SÜD Chief Information Security Officer (CISO)',
      subtitle: '— New Batch Starting Soon!',
      component: 'sticky_cta_bar',
      cta_label: 'Enquire Now',
    },
    {
      _uid: '02861604-0d1a-457d-8093-1ef870be6344',
      enabled: true,
      qr_hint: 'Or scan with your phone',
      component: 'whatsapp_widget',
      nudge_text: 'Need help? Chat with us!',
      header_title: 'TÜV SÜD India',
      bubble_line_1: 'Hi there! Interested in the Chief Information Security Officer (CISO) Career Path?',
      bubble_line_2: 'Chat with us for instant answers about the programme, fees, schedule & more.',
      open_cta_label: 'Open WhatsApp Chat',
      header_subtitle: 'Course Counsellor',
      reply_time_text: 'Typically replies within minutes',
      whatsapp_number: '919186556246',
      prefilled_message:
        "Hi, I'm interested in the TÜV SÜD Chief Information Security Officer (CISO) Career Path. Could you share more details?",
    },
  ],
} satisfies StaticLandingPage;
